import { useCallback, useRef } from 'react';
import { Metrics } from '../metrics/Metrics';
/**
 * Track the time between clicking into "<object_type> properties"
 *   and rendering the properties
 *   the first time it happens
 *   where <object_type> is `baseFilterFamily`
 *   by wrapping `dispatch` with stateful tracking behavior
 */
export const useRenderPropertiesTracked = dispatch => {
  const hasTrackedPropertyRenderDuration = useRef(false);
  const selectObjectOwnFilterBranchTime = useRef();
  return useCallback(action => {
    var _action$payload;
    // Track the start time
    if (action.type === 'filterFamily' && // clicked into baseFilterFamily properties
    (_action$payload = action.payload) !== null && _action$payload !== void 0 && (_action$payload = _action$payload.filterFamilyInfo) !== null && _action$payload !== void 0 && _action$payload.isObjectOwnFilterBranch &&
    // this is the first time
    typeof selectObjectOwnFilterBranchTime.current === 'undefined') {
      selectObjectOwnFilterBranchTime.current = window.performance.now();
    }
    // Send the metric
    if (action.type === 'fieldsLoaded' &&
    // We havn't sent this metric yet
    !hasTrackedPropertyRenderDuration.current &&
    // This fieldsLoaded event corresponds to the event of interest
    typeof selectObjectOwnFilterBranchTime.current !== 'undefined') {
      // Prevent us from tracking this more than once
      hasTrackedPropertyRenderDuration.current = true;
      // In the next event loop properties will have rendered
      window.setTimeout(() => {
        if (typeof selectObjectOwnFilterBranchTime.current !== 'undefined') {
          // Uncomment to show timing in dev tools:
          // window.performance.measure('properties_rendered', {
          //   start: selectObjectOwnFilterBranchTime.current,
          // });
          Metrics.timer('properties_rendered').update(window.performance.now() - selectObjectOwnFilterBranchTime.current);
        }
      });
    }
    dispatch(action);
  }, [dispatch]);
};